"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ActionsMenu = _interopRequireDefault(require("./ActionsMenu"));

var _SVGIcon = _interopRequireDefault(require("./SVGIcon"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const addUnit = val => {
  return /^\d*\.?\d+$/.test(val) ? `${val}px` : val;
};

const Content = _styledComponents.default.div.withConfig({
  displayName: "Dialog__Content",
  componentId: "sc-18ah6jw-0"
})([" ", ""], p => (0, _styledComponents.css)(["display:flex;flex-direction:column;position:relative;z-index:1002;background:#fff;color:#666;padding:32px;width:", ";", ";", ";max-height:calc(100vh - ", " - 32px);box-shadow:2px 16px 32px 0 rgba(0,0,0,0.5);border-radius:4px;overflow:hidden;overflow-y:auto;", ";"], addUnit(p.width), p.top !== undefined && (0, _styledComponents.css)(["top:", ";"], addUnit(p.top)), p.height !== undefined && (0, _styledComponents.css)(["height:", ";"], addUnit(p.height)), addUnit(p.top), p => p.fullHeight && (0, _styledComponents.css)(["top:0;height:100vh;max-height:100vh;border:0;border-radius:0;"])));

const Background = _styledComponents.default.div.withConfig({
  displayName: "Dialog__Background",
  componentId: "sc-18ah6jw-1"
})(["position:fixed;z-index:1001;top:0;left:0;width:100%;height:100%;background-color:rgba(0,0,0,0.2);"]);

const Header = _styledComponents.default.div.withConfig({
  displayName: "Dialog__Header",
  componentId: "sc-18ah6jw-2"
})(["display:flex;align-items:center;margin-bottom:24px;"]);

const Title = _styledComponents.default.h1.withConfig({
  displayName: "Dialog__Title",
  componentId: "sc-18ah6jw-3"
})([" ", ""], p => (0, _styledComponents.css)(["flex:1;font-size:22px;font-weight:300;line-height:32px;color:#444;margin-top:-8px;", ";"], p.centerTitle && (0, _styledComponents.css)(["text-align:center;"])));

const CloseIcon = (0, _styledComponents.default)(_SVGIcon.default).withConfig({
  displayName: "Dialog__CloseIcon",
  componentId: "sc-18ah6jw-4"
})(["position:absolute;right:24px;top:24px;"]);

const Scrollable = _styledComponents.default.div.withConfig({
  displayName: "Dialog__Scrollable",
  componentId: "sc-18ah6jw-5"
})(["flex:1;display:flex;flex-direction:column;overflow:hidden;overflow-y:auto;", ";"], p => p.contentStyle && p.contentStyle);

const MenuWrapper = _styledComponents.default.div.withConfig({
  displayName: "Dialog__MenuWrapper",
  componentId: "sc-18ah6jw-6"
})(["position:absolute;right:72px;top:24px;width:48px;height:32px;border-right:1px solid #afafaf;"]);

const Dialog = ({
  className,
  title,
  centerTitle,
  width = 928,
  height,
  top = 72,
  menuItems,
  onMenuSelect,
  dialogContentClassName,
  onClose,
  contentStyle,
  fullHeight,
  children
}) => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(Content, {
    className: dialogContentClassName,
    width: width,
    height: height,
    top: top,
    fullHeight: fullHeight
  }, /*#__PURE__*/_react.default.createElement(Header, null, /*#__PURE__*/_react.default.createElement(Title, {
    centerTitle: centerTitle
  }, title), menuItems && menuItems.length > 0 && /*#__PURE__*/_react.default.createElement(MenuWrapper, null, /*#__PURE__*/_react.default.createElement(_ActionsMenu.default, {
    items: menuItems,
    onMenuSelect: onMenuSelect
  })), onClose && /*#__PURE__*/_react.default.createElement(CloseIcon, {
    name: "close",
    color: "#afafaf",
    hoverColor: "#666",
    onClick: onClose
  })), /*#__PURE__*/_react.default.createElement(Scrollable, {
    contentStyle: contentStyle
  }, children)), /*#__PURE__*/_react.default.createElement(Background, {
    onClick: onClose
  }));
};

var _default = (0, _styledComponents.default)(Dialog).withConfig({
  displayName: "Dialog",
  componentId: "sc-18ah6jw-7"
})(["position:fixed;z-index:1000;top:0;left:0;width:100%;height:100%;display:flex;flex-direction:column;align-items:center;"]);

exports.default = _default;